import React from "react";

const STATUS_STYLES = {
  "Filed": "bg-blue-50 text-blue-800 border-blue-200",
  "Pending": "bg-blue-50 text-blue-800 border-blue-200",
  "Notice Issued": "bg-purple-50 text-purple-800 border-purple-200",
  "Under Consideration": "bg-slate-50 text-slate-700 border-slate-200",
  "Interim Directions Issued": "bg-amber-50 text-amber-800 border-amber-200",
  "Relief Granted": "bg-emerald-50 text-emerald-800 border-emerald-200",
  "Partly Allowed": "bg-emerald-50 text-emerald-800 border-emerald-200",
  "Disposed": "bg-emerald-50 text-emerald-800 border-emerald-200",
  "Decided": "bg-emerald-50 text-emerald-800 border-emerald-200",
  "Closed": "bg-slate-100 text-slate-700 border-slate-300",
};

export default function StatusPill({ status, className = "" }) {
  if (!status) return null;
  const cls = STATUS_STYLES[status] || "bg-slate-50 text-slate-700 border-slate-200";
  return (
    <span
      data-testid="pil-status-pill"
      className={`inline-flex items-center gap-1.5 text-[11px] font-sans uppercase tracking-[0.12em] font-semibold px-2.5 py-1 rounded-full border ${cls} ${className}`}
    >
      <span className="w-1.5 h-1.5 rounded-full bg-current opacity-70" />
      {status}
    </span>
  );
}
